Dropzone.autoDiscover = false;
angular.module('dropzone', []).directive('dropzone', function () {
    return function (scope, element, attrs) {
        var config, dropzone;
        config = scope['vm'][attrs.dropzone];
        // create a Dropzone for the element with the given options
        dropzone = new Dropzone(element[0], config.options);

        // bind the given event handlers
        angular.forEach(config.eventHandlers, function (handler, event) {
            dropzone.on(event, handler);
            dropzone.on("complete", function (file) {
                dropzone.removeFile(file);
            });
        });
    };
});

window.directives = window.directives || ['ngSanitize', 'ngAnimate', 'angularTrix', 'dropzone', 'colorpicker', 'ui.select', 'DualMultiSelect'];
window.app = angular.module('app', window.directives).config(function () {
    angular.lowercase = angular.$$lowercase;
});

window.app.filter("asDate", function () {
    return function (input) {
        return window.__mt.fn.getDate(input);
    }
})
